<template>
  <PageLayout
    class="work-home"
    :leftArrow="false"
    langChooseLocation="left"
    navBarSlot="right"
    :clickLeft="() => {}"
  >
    <template #right>
      <p
        class="work-home-history-btn"
        @click="goToPage('list', 'clickHomeTopGoOrderList')"
      >
        <van-badge :dot="hasRedDot">
          <van-icon
            name="underway-o"
            size="15"
            class="work-home-history-btn-ico"
          />{{ languages.mylist_headerTitle }}
        </van-badge>
      </p>
    </template>
    <div class="work-home-wrap">
      <faq-notice-bar :source="locationType.homePage"></faq-notice-bar>
      <template v-if="faqSiteName && hasFaqClassList">
        <section-title :title="languages.smartOrderNeedHelp"></section-title>
        <van-form class="work-home-search">
          <van-search
            class="search"
            :placeholder="languages.smartOrderInputQuestion"
            background="transparent"
            @click="goToPage('workSearch', 'clickHomeGoSearch')"
          >
            <template #left-icon>
              <div></div>
            </template>
            <template #right-icon>
              <van-icon name="search" class="search-ico" />
            </template>
          </van-search>
        </van-form>
      </template>
      <section-title
        :title="languages.smartOrderCreate"
        v-show="hasWorkTempList && !isJumpAiBot"
      ></section-title>
      <work-temp-list
        v-show="hasWorkTempList && !isJumpAiBot"
        :source="locationType.homePage"
      ></work-temp-list>
      <template v-if="hasFaqClassList || (isLogin && isJumpAiBot)">
        <section-title :title="languages.smartOrderLookHelpTip"></section-title>
        <div class="work-home-faq">
          <div
            class="work-home-faq-item"
            v-for="item in faqClassList"
            :key="item.id"
            @click="goToFaqList(item.id)"
          >
            <img
              :src="item.icon"
              class="work-home-faq-item-ico"
              v-if="item.icon"
            />
            <em class="icon iconfont icon-box" v-else></em>
            <div class="work-home-faq-item-text">
              <p class="van-ellipsis">{{ item.text }}</p>
              <van-icon name="arrow" size="16" class="icon" />
            </div>
          </div>
          <div
            class="work-home-faq-item"
            @click="contactService"
            v-if="isLogin && isJumpAiBot"
          >
            <em class="icon iconfont icon-service"></em>
            <div class="work-home-faq-item-text">
              <p class="van-ellipsis">
                {{ languages.smartOrderContactService }}
              </p>
              <van-icon name="arrow" size="16" class="icon" />
            </div>
            <span class="beta">BETA</span>
          </div>
        </div>
      </template>
    </div>
    <!-- <ContactServerBtn
      class="service-btn"
      :customClick="contactService"
      v-if="isLogin && isJumpAiBot"
    ></ContactServerBtn> -->
    <NoticePopup
      v-bind:visible.sync="isNoticePopup"
      :languages="languages"
      :noticeList="noticeList"
      @closePopup="isNoticePopup = false"
    ></NoticePopup>
    <AiBotPopup
      v-bind:visible.sync="showAiBotPopup"
      :aiBotLink="aiBotLink"
    ></AiBotPopup>
  </PageLayout>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import SectionTitle from '@components/officialSupport/common/SectionTitle.vue';
import WorkTempList from '@components/officialSupport/WorkTempList.vue';
import NoticePopup from '@components/officialSupport/NoticePopup.vue';
import FaqNoticeBar from '@components/officialSupport/FaqNoticeBar.vue';
import AiBotPopup from '@components/officialSupport/AiBotPopup.vue';
import globalConfig from '@utiles/globalConfig';
import {
  clickButton,
  locationType,
  showPopup
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import ContactServerBtn from '@components/officialSupport/ContactServerBtn.vue';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import aiBot from '@mixins/officialSupport/aiBot';
let from = globalConfig.getHrefParam('from');
const isAi = globalConfig.getHrefParam('ai') == '1';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'WorkHome',
  mixins: [pointStayTime, iframeMessage, aiBot],
  data() {
    return {
      openNoticePopup: false, // 是否开启客服公告弹框
      hasShowedNoticePopup: false, // 是否弹过，弹过一次之后不再弹，刷新页面重新请求接口
      isNoticePopup: false,
      noticeList: [],
      isExeUserCenter: ['pnsClient', 'exeClient'].includes(from), // 是否是微端打开
      isExe: globalConfig.getHrefParam('device') == 'exe',
      gameId:
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id') ||
        '',
      locationType,
      hasRedDot: false,
      // showAiBtn: isAi,
      showAiBotPopup: false
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mylist,
      curLang: state => state.curLang,
      faqSiteName: state => state.faqSiteName,
      faqClassList: state => state.faqClassList,
      workTempList: state => state.workTempList,
      isLogin: state => state.isLogin
    }),
    ...mapGetters(['hasFaqClassList', 'hasWorkTempList'])
  },
  watch: {
    $route: {
      handler(newRoute, oldRoute) {
        if (newRoute?.name == 'workhome') {
          this.checkHasNewReply();
        }
      },
      deep: true
    }
  },
  async created() {
    this.getNoticePopup().then(() => {
      this.checkShowNoticePopup();
    });
    this.checkHasNewReply();
  },

  methods: {
    ...mapActions([
      'getNoticePopupConfig',
      'postShowNoticeRecord',
      'getWorkList'
    ]),
    goToFaqList(id) {
      clickButton({
        btnName: 'clickFaqFirstClass',
        locationKey: locationType.homePage,
        otherParams: {
          faqClassId: id
        }
      });
      this.$router.push({
        path: '/workfaqlist',
        query: {
          firstClassId: id
        }
      });
    },
    goToPage(name, pointEventName) {
      const pageName = {
        list: 'mylist',
        workSearch: 'worksearch'
      };
      if (pointEventName) {
        clickButton({
          btnName: pointEventName,
          locationKey: locationType.homePage
        });
      }
      pageName[name] && this.$router.push(`/${pageName[name]}`);
    },
    checkShowNoticePopup() {
      if (this.openNoticePopup && !this.hasShowedNoticePopup) {
        this.isNoticePopup = true;
        this.hasShowedNoticePopup = true;
        this.sendShowNoticeRecord();
        showPopup(locationType.noticePopup);
      }
    },
    sendShowNoticeRecord() {
      this.postShowNoticeRecord({
        announcement_id: this.noticeList.map(item => item.id).join(',')
      });
    },
    getNoticePopup() {
      return new Promise(async resolve => {
        const serverId = globalConfig.getHrefParam('serverId');
        let newDevicePlate = globalConfig.getHrefParam('devicePlate');
        const devicePlate = globalConfig.getHrefParam('devicePlate');
        if (['pc', 'h5'].includes(devicePlate)) {
          if (this.isExeUserCenter || this.isExe) {
            newDevicePlate = 'pc';
          } else {
            newDevicePlate = 'h5';
          }
        }
        try {
          const data = await this.getNoticePopupConfig({
            game_id: this.gameId,
            server_id: serverId,
            devicePlate: newDevicePlate,
            zone: this.curLang
          });
          if (data?.has_announce) {
            this.openNoticePopup = true;
            this.noticeList = data?.announcement || [];
            resolve();
          } else {
            resolve();
          }
        } catch (error) {
          resolve();
        }
      });
    },
    async checkHasNewReply() {
      const data = await this.getWorkList({
        is_check_unread: true
      });
      this.hasRedDot = +data?.UNREAD_COUNT > 0 || false;
    },
    contactService() {
      clickButton({
        btnName: 'clickContactService',
        locationKey: locationType.homePage,
        otherParams: {
          frontVersion: `v1_${new Date().getTime()}`,
          isOpenAiEntrance: this.isJumpAiBot,
          isLogin: this.isLogin
        }
      });
      this.handleContactService('homeBtn');
    }
  },
  components: {
    PageLayout,
    SectionTitle,
    WorkTempList,
    NoticePopup,
    FaqNoticeBar,
    ContactServerBtn,
    AiBotPopup
  }
};
</script>

<style lang="scss" scoped>
.work-home {
  &-wrap {
    padding: 0 10px;
    box-sizing: border-box;
  }
  &-history-btn {
    display: flex;
    align-items: center;
    color: var(--text-color);
    font-size: 14px;
    &-ico {
      margin-right: 5px;
      color: var(--text-color) !important;
    }
  }
  &-search {
    z-index: 2;
    background-color: var(--page-bgColor);
    ::v-deep .van-field__clear {
      padding: 0 8px 0 16px !important;
    }
    .search {
      overflow: hidden;
      width: 100%;
      padding: 0;
      margin: 0 auto 26px;
      border-radius: 8px;

      ::v-deep .van-field__control {
        color: var(--text-color);
        caret-color: transparent;

        &::after {
          display: none;
        }
      }

      ::v-deep .van-field {
        line-height: 34px;
      }
      ::v-deep .van-icon-search {
        font-size: 24px;
        font-weight: bold;
        color: #767676;
      }
      ::v-deep .van-search__content {
        background-color: var(--block-bg-light-color);
        border-radius: 8px;
        padding-left: 10px;
      }
    }
  }
  &-faq {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr)); /* 防止内容溢出 */
    grid-auto-rows: auto; /* 多行 */
    grid-gap: 16px; /* 列中间间隔随意 */
    justify-content: space-between; /* 列靠边对齐 */
    width: 100%;
    margin: 0 auto 16px;
    &-item {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 20px;
      width: 187px;
      max-width: 100%; // 最大宽度为网格宽度，防止内容溢出
      height: 120px;
      border-radius: 20px;
      box-sizing: border-box;
      background-color: var(--block-bg-light-color);
      cursor: pointer;
      &-ico {
        color: var(--main-color);
        width: 40px;
      }
      &-text {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 500;
        .icon {
          display: block;
          font-size: 16px;
          color: var(--back-color);
        }
      }
    }
    .beta {
      position: absolute;
      top: 20px;
      right: 20px;
      color: var(--main-color);
      line-height: 18px;
      font-weight: 500;
      font-size: 10px;
      padding-left: 4px;
      padding-right: 4px;
      border-radius: 5px;
      border: 1px solid var(--main-color);
    }
  }
  .icon {
    font-size: 40px;
    color: var(--main-color);
  }
  .service-btn {
    display: block;
    position: relative;
    bottom: unset;
    right: unset;
  }
}
// 横屏兼容
@media screen and (orientation: landscape) {
  .work-home-faq {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    &-item {
      width: 200px;
    }
  }
}
</style>
